export default [
    {
        path: '/yuce/pingshen',
        name: '/yuce/pingshen',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/pingshen.vue'),

    },
    //内销详情
    {
        path: '/yuce/xiangqing',
        name: '/yuce/xiangqing',
        component: () => import( '@/views/loud/yuce/xiangqing.vue'),
    },
    // 内销列表汇总
    {
        path: '/yuce/sellOn_list',
        name: '/yuce/sellOn_list',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/sellOn_list.vue'),
        meta: {keepAlive:true, title: '预测列表',
            isTabsPage: true
        }
    },
    // 内销审核
    {
        path: '/yuce/nxshenhe',
        name: '/yuce/nxshenhe',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/nxshenhe.vue'),

    },
    // 外销列表汇总
    {
        path: '/yuce/wxhuizong',
        name: '/yuce/wxhuizong',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxhuizong.vue'),
        meta: {keepAlive:true}
    },
	// 外销列表汇总1
	{
	    path: '/yuce/wxhuizong1',
	    name: '/yuce/wxhuizong1',
	    // which is lazy-loaded when the route is visited.
	    component: () => import( '@/views/loud/yuce/wxhuizong1.vue'),

	},
    // 新增外销数据
    {
        path: '/yuce/export_list',
        name: '/yuce/export_list',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/export_list.vue'),
    },
    // 外销数据详情
    {
        path: '/yuce/wxxiangqing',
        name: '/yuce/wxxiangqing',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxxiangqing.vue'),
        meta: {
            title: '新增预测',
            isTabsPage: true,
            keepAlive:false
        }
    },
    // 内销总部列表
    {
        path: '/yuce/domesticList_screening',
        name: '/yuce/domesticList_screening',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/domesticList_screening.vue'),
        meta: {keepAlive:true, title: '国内市场',
            isTabsPage: true
        }
    },
    // 外销审核
    {
        path: '/yuce/wxshenhe',
        name: '/yuce/wxshenhe',
        // which is lazy-loaded when the route is visited.
        // component: () => import( '@/views/loud/yuce/wxshenhe.vue'),
        component: () => import( '@/views/loud/yuce/wxxiangqing/shenheYuce.vue'),
    },
    {
        path: '/yuce/wxOthershenhe',
        name: '/yuce/wxOthershenhe',
        // which is lazy-loaded when the route is visited.
        // component: () => import( '@/views/loud/yuce/wxOthershenhe.vue'),
        component: () => import( '@/views/loud/yuce/wxxiangqing/shenheOtherYuce.vue'),
    },
    //预排订单
    {
        path: '/yuce/wxxiangqingPre',
        name: '/yuce/wxxiangqingPre',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxxiangqingPre.vue'),
        meta: {
            title: '预排订单',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //预排审批
    {
        path: '/yuce/wxshenhePre',
        name: '/yuce/wxshenhePre',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxshenhePre.vue'),
    },
    {
        path: '/yuce/wxshenheClosePre',
        name: '/yuce/wxshenheClosePre',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxshenheClosePre.vue'),
    },
    {
        path: '/yuce/wxreSubmitPre',
        name: '/yuce/wxreSubmitPre',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxreSubmitPre.vue'),
    },
    // 外销下单审核
    {
        path: '/yuce/jiediaoshenhe',
        name: '/yuce/jiediaoshenhe',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/jiediaoshenhe.vue'),
    },
    //内销预测报表
    {
        path: '/yuce/yuceReport',
        name: '/yuce/yuceReport',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/yuceReport.vue'),
        meta: {
            title: '预测报表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //外销预测报表
    {
        path: '/yuce/wxyuceReport',
        name: '/yuce/wxyuceReport',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceReport.vue'),
        // meta: {keepAlive:true, pageFlag: 'bd'}
        meta: {keepAlive:true,title: '外销报表',
            isTabsPage: true
        }
    },
    //外销预测报表-已撤单
    {
        path: '/yuce/wxyuceReport-ycd',
        name: '/yuce/wxyuceReport-ycd',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceReport-ycd.vue'),
        // meta: {keepAlive:true, pageFlag: 'bd'}
        meta: {keepAlive:true, title: '已撤单',
            isTabsPage: true
        }
    },
    //外销预测报表
    {
        path: '/yuce/wxyuceReport-goods',
        name: '/yuce/wxyuceReport-goods',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceReport-goods.vue'),
        meta: {keepAlive:true,title: '已发货',
            isTabsPage: true
        }
    },
    //外销预测报表
    {
        path: '/yuce/wxyuceReport-public',
        name: '/yuce/wxyuceReport-public',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceReport-public.vue'),
        meta: {keepAlive:true, title: '公用库存',
            isTabsPage: true
        }
    },
    //外销预测周报表
    {
        path: '/yuce/wxycWeekReport',
        name: '/yuce/wxycWeekReport',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxycWeekReport.vue'),
        meta: {keepAlive:true,title: '外销周报表',
            isTabsPage: true
        }
    },
    //外销预测占用列表
    {
        path: '/yuce/yuceOccupy',
        name: '/yuce/yuceOccupy',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/yuceOccupy.vue'),
    },
    //内销预测修改页面
    {
        path: '/yuce/yuceRevise',
        name: '/yuce/yuceRevise',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/yuceRevise.vue'),
    },
    // 外销定制审核
    {
        path: '/yuce/wxdzshenhe',
        name: '/yuce/wxdzshenhe',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxdzshenhe.vue'),
    },
    // 预测撤单审核
    {
        path: '/yuce/withdrawshenhe',
        name: '/yuce/withdrawshenhe',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/withdrawshenhe.vue'),
    },
    // 外销预测修改数据
    {
        path: '/yuce/wxyuceRevise',
        name: '/yuce/wxyuceRevise',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceRevise.vue'),
    },
    //外销预测修改审核
    {
        path: '/yuce/wxReviseshenhe',
        name: '/yuce/wxReviseshenhe',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxReviseshenhe.vue'),
    },
    //外销预测修改他人审核
    {
        path: '/yuce/wxReviseshenheOther',
        name: '/yuce/wxReviseshenheOther',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxReviseshenheOther.vue'),
    },
    //外销预测重新提报
    {
        path: '/yuce/wxreSubmit',
        name: '/yuce/wxreSubmit',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxreSubmit.vue'),
    },
    //代办查看页面
    {
        path: '/yuce/showXiangqing',
        name: '/yuce/showXiangqing',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/showXiangqing.vue'),
    },
    //修改库存审核页面
    {
        path: '/yuce/wxRevisekucun',
        name: '/yuce/wxRevisekucun',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxRevisekucun.vue'),
    },
    //外销预测报表(汇总)
    {
        path: '/yuce/wxyuceReport-summary',
        name: '/yuce/wxyuceReport-summary',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceReport-summary.vue'),
        meta: {keepAlive:true, title: '外销汇总',
            isTabsPage: true
        }
    },
    //外销预测报表(库存)
    {
        path: '/yuce/wxyuceReport-inventory',
        name: '/yuce/wxyuceReport-inventory',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxyuceReport-inventory.vue'),
        // meta: {keepAlive:true, pageFlag: 'kc'}
        meta: {keepAlive:true,title: '外销库存',
            isTabsPage: true
        }
    },
    //库存报表
    {
        path: '/yuce/inventoryTable',
        name: '/yuce/inventoryTable',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/inventoryTable/inventoryTable.vue'),
        // meta: {keepAlive:true, pageFlag: 'kc'}
        meta: {keepAlive:true,title: '库存明细报表',
            isTabsPage: true
        }
    },
    //外销新增预测（新）
    {
        path: '/yuce/createForcast',
        name: '/yuce/createForcast',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/wxxiangqing/createYuce.vue'),
    },
    // 外销预测型号经理审核
    {
        path: '/yuce/wxshenheXhjl',
        name: '/yuce/wxshenheXhjl',
        // which is lazy-loaded when the route is visited.
        // component: () => import( '@/views/loud/yuce/wxshenhe.vue'),
        component: () => import( '@/views/loud/yuce/wxxiangqing/shenheYuceXhjl.vue'),
    },
    // 外销预测查看详情
    {
        path: '/yuce/yuceXiangqing',
        name: '/yuce/yuceXiangqing',
        // which is lazy-loaded when the route is visited.
        // component: () => import( '@/views/loud/yuce/wxshenhe.vue'),
        component: () => import( '@/views/loud/yuce/wxxiangqing/yuceXiangqing.vue'),
    },
    // 外销预测修改
    {
        path: '/yuce/yuceUpdate',
        name: '/yuce/yuceUpdate',
        // which is lazy-loaded when the route is visited.
        // component: () => import( '@/views/loud/yuce/wxshenhe.vue'),
        component: () => import( '@/views/loud/yuce/wxxiangqing/updateYuce.vue'),
    },
    // 外销数据详情
    {
        path: '/yuce/reformDetail',
        name: '/yuce/reformDetail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/yuce/ViewReformDetail.vue'),
        meta: {
            title: '改制明细',
            isTabsPage: true,
            keepAlive:false
        }
    },
]
